module.exports = __webpack_public_path__ + "img/watermark.ce460748.png";